import React, { useState } from 'react';
import { Select, MenuItem, makeStyles, withStyles } from '@material-ui/core';
import NestedMenuItem from "material-ui-nested-menu-item";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useMenuItemClasses } from '../Navigator/TreeContextMenu';
import Divider from '@material-ui/core/Divider';

const useMinimalSelectClasses = makeStyles({
    select: {
        minWidth: 90,
        minHeight: 'unset',
        color: '#555555',
        fontWeight: 400,
        fontSize: 14,
        borderStyle: 'none',
        borderWidth: 2,
        borderRadius: 4,
        padding: '6px 4px 6px 12px',
        margin: '8px 0 4px 0px',
        boxShadow: '0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)',
        "&:focus": {
            borderRadius: 4,
            background: 'white',
            borderColor: 'lightgray',
        },
    },
    icon: {
        color: 'gray',
        right: 12,
        position: 'absolute',
        userSelect: 'none',
        pointerEvents: 'none',
    },
    paper: {
        borderRadius: 3,
        marginTop: 5
    },
    menuItemRoot: {
        lineHeight: 1.2,
        padding: '4px 10px',
        minHeight: 'unset',
    }
});


const MinimalSelect = ({ value, onSelect, options, placeHolder }) => {
    const minimalSelectClasses = useMinimalSelectClasses();
    const menuItemClasses = useMenuItemClasses();

    const iconComponent = ({ className }) => ( <ExpandMoreIcon className={className + " " + minimalSelectClasses.icon} /> );
    const items = options.map(opt => typeof opt === 'string' ? { label: opt, value: opt } : opt );

    // moves the menu below the select input
    const menuProps = {
        classes: {
            paper: minimalSelectClasses.paper,
            // list: minimalSelectClasses.list
        },
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
    };

    return (
        <Select
            disableUnderline
            classes={{ root: minimalSelectClasses.select }}
            MenuProps={menuProps}
            IconComponent={iconComponent}
            value={value}
            displayEmpty={Boolean(placeHolder)}
            renderValue={(o) => o || placeHolder}
            onChange={onSelect}
        >
            { items.map((item, i) => ( item.submenu ? (
                <NestedMenuItem key={item.label} classes={menuItemClasses} label={item.label} parentMenuOpen>
                    { item.submenu.map((subitem, k) => (
                        <MenuItem key={subitem.label} classes={menuItemClasses} disabled={subitem.disabled} onClick={() => setOpen(false)}>{subitem.label}</MenuItem>
                    ))}
                </NestedMenuItem>
            ) : (item.label === '-' ? (
                <Divider key={i} />
            ) : (
                <MenuItem classes={{ root: minimalSelectClasses.menuItemRoot }} key={i} disabled={item.disabled} value={item.value}>{item.label}</MenuItem>)
            )))}
        </Select>
    );
};

export default MinimalSelect;
